import React, { Component } from "react";
import mousetrap from "mousetrap";
import { Button } from "antd";
import { UnAuthAppBox } from "../common/index";
import { TextInput } from "../common/";
import "./newPasswordView.scss";

class NewPasswordView extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    mousetrap.bind("enter", this.submit);
  }

  componentWillUnmount() {
    mousetrap.bind("enter", this.submit);
  }

  handleInputChange(event) {
    this.props.changeInputValue("newPassword", event);
  }

  getToken() {
    const searchString = this.props.location.search || "";
    const tokenRegexp = /\?token=([^&]+)/;
    const result = tokenRegexp.exec(searchString);
    return result ? result[1] : null;
  }
  submit() {
    const token = this.getToken();
    if (!token) return;
    this.props.saveNewPassword(token);
  }
  render() {
    const { uiState } = this.props;
    const { password, confirmPassword, errors, state: resetState } = uiState;
    const showSuccessMessage = resetState === "success";
    if (showSuccessMessage) {
      return (
        <div className="c-login">
          <UnAuthAppBox>
            <div className="c-passwordReset__title">
              Hasło zostało zmienione
            </div>
            <p className="c-passwordReset__infoText">
              Zaloguj się w panelu logowania za pomocą nowego hasła.
            </p>
          </UnAuthAppBox>
        </div>
      );
    }

    const loading = resetState === "loading";
    return (
      <div className="c-login">
        <UnAuthAppBox>
          <div className="c-passwordReset__title">Ustaw nowe hasło</div>
          <TextInput
            id="password"
            value={password}
            onChange={this.handleInputChange}
            type="password"
            label="Hasło"
            inputClassName="mousetrap"
            error={errors["password"]}
          />
          <TextInput
            id="confirmPassword"
            value={confirmPassword}
            onChange={this.handleInputChange}
            type="password"
            label="Powtórz hasło"
            inputClassName="mousetrap"
            error={errors["confirmPassword"]}
          />
          <Button
            loading={loading}
            type="primary"
            modifiers={["purple"]}
            onClick={this.submit}
            className={"loginButton"}
          >
            {loading ? "Zapisywanie" : "Zapisz"}
          </Button>
        </UnAuthAppBox>
      </div>
    );
  }
}

export default NewPasswordView;
